export function phoneHref(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) {
    return '#';
  }

  return `tel:+${digits.startsWith('8') ? `7${digits.slice(1)}` : digits}`;
}

export function whatsappHref(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  const normalized = digits.startsWith('8') ? `7${digits.slice(1)}` : digits;
  return `https://wa.me/${normalized}`;
}

export function mailHref(email) {
  return `mailto:${email}`;
}

export function makeId(prefix) {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

export function moveItem(items, index, direction) {
  const targetIndex = index + direction;
  if (targetIndex < 0 || targetIndex >= items.length) {
    return items;
  }

  const nextItems = [...items];
  const [item] = nextItems.splice(index, 1);
  nextItems.splice(targetIndex, 0, item);
  return nextItems;
}

